import { useEffect } from 'react';

export default function NotFound() {
  useEffect(() => {
    document.title = 'Page introuvable — Tohu Bohu';
  }, []);
  return (
    <main className="not-found">
      <div className="not-found__code" aria-hidden="true">404</div>
      <h1>Cette page n’existe pas.</h1>
      <p>Le lien a peut-être changé. Retrouvez les solutions d’intelligence relationnelle depuis l’accueil.</p>
      <a href="/">Retour à l’accueil →</a>
    </main>
  );
}
